/**
 * Mutación para poner información del nivel de afiliación seleccionado en el detalle de la afiliación.
 * @param {State} state Estado de Vue.
 * @param {Object} affiliation Objeto del nivel de affiliación seleccionado por el usuario.
 */
export function setAffiliationInformation(state, affiliation) {
    state.currentTier = affiliation
}

/**
 * Mutación que limpia el objecto del nivel de la afiliación seleccionada por el usuario
 * @param {State} state Estado de Vue.
 */
export function clearTier(state) {
    state.currentTier = {};
}

/**
 * Mutación que guarda las afiliaciones de un usuario de tipo afiliado.
 * @param {State} state Estado de Vue.
 * @param {Array<Object>} affiliations Arreglo de afiliaciones que tiene el usuario.
 */
export function setUserAffiliationInformation(state, affiliations) {
    state.userAffiliations = affiliations
}

/**
 * Mutación que guarda las transacciones de afiliaciones que tiene una organización.
 * @param {State} state Estado de Vue.
 * @param {Array<Object>} affiliations Arreglo de transacciones de afiliaciones que tiene una organización.
 */
export function setOrganizationAffiliations(state, affiliations) {
    state.organizationAffiliations = affiliations;
}